import { render, staticRenderFns } from "./child.vue?vue&type=template&id=4b008565&scoped=true"
import script from "./child.vue?vue&type=script&lang=js"
export * from "./child.vue?vue&type=script&lang=js"
import style0 from "./child.vue?vue&type=style&index=0&id=4b008565&prod&lang=scss"
import style1 from "./child.vue?vue&type=style&index=1&id=4b008565&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b008565",
  null
  
)

export default component.exports